import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Lock, User as UserIcon, ArrowRight, ShieldCheck } from "lucide-react";
import { FREEAYTO_LOGO } from "../../data/mock";

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin", { replace: true });
    } catch (e) {
      setErr(
        e?.response?.data?.detail ||
          "Login fehlgeschlagen. Bitte Zugangsdaten prüfen."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center px-6 py-12 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.18),rgba(249,115,22,0.10)_30%,rgba(168,85,247,0.06)_50%,transparent_70%)]" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={FREEAYTO_LOGO} alt="FREEAYTO" className="h-16 w-auto" />
        </div>

        <div className="p-8 md:p-10 rounded-3xl bg-white/5 backdrop-blur-xl border border-white/10">
          <div className="flex items-center gap-2 mb-1">
            <ShieldCheck size={16} className="text-pink-400" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-neutral-300">
              Admin Login
            </span>
          </div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">
            Backoffice
          </h1>
          <p className="mt-2 text-sm text-neutral-400">
            Melde dich an, um Anfragen zu verwalten.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div className="relative">
              <UserIcon
                size={16}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-500"
              />
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Benutzername"
                autoComplete="username"
                className="w-full pl-11 pr-4 py-4 rounded-2xl bg-white/5 border border-white/10 focus:border-pink-400 focus:bg-white/10 outline-none text-white placeholder:text-neutral-500"
              />
            </div>
            <div className="relative">
              <Lock
                size={16}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-500"
              />
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Passwort"
                autoComplete="current-password"
                className="w-full pl-11 pr-4 py-4 rounded-2xl bg-white/5 border border-white/10 focus:border-pink-400 focus:bg-white/10 outline-none text-white placeholder:text-neutral-500"
              />
            </div>

            {err && (
              <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-sm">
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-3 px-7 py-4 rounded-full bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 text-white text-sm font-bold tracking-[0.12em] uppercase hover:shadow-[0_18px_42px_-10px_rgba(236,72,153,0.7)] hover:-translate-y-[2px] transition-all duration-300 disabled:opacity-60"
            >
              {loading ? "Anmelden…" : "Anmelden"}
              <ArrowRight size={16} />
            </button>
          </form>
        </div>
        <div className="mt-6 text-center">
          <a href="/" className="text-xs text-neutral-500 hover:text-white transition-colors">
            ← Zurück zur Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
